const t = {
  name: "PayLater",
  dimensions: { width: 24, height: 23 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">
      <path d="M16 9.5V3.5C16 2.4 15.1 1.5 14 1.5H3C1.9 1.5 1 2.4 1 3.5V5.5V10.5C1 11.6 1.9 12.5 3 12.5H11.5"/>
      <path d="M1 5.5H16"/>
      <path d="M17 21.5C20.3137 21.5 23 18.8137 23 15.5C23 12.1863 20.3137 9.5 17 9.5C13.6863 9.5 11 12.1863 11 15.5C11 18.8137 13.6863 21.5 17 21.5Z"/>
      <path d="M17 13.5V15.5H19"/>
    </g>
  `
};
export {
  t as PayLater
};
